/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const availableTaillightColors = /* GraphQL */ `
  query AvailableTaillightColors {
    availableTaillightColors
  }
`;
export const carPrintableLabel = /* GraphQL */ `
  query CarPrintableLabel($instanceId: String) {
    carPrintableLabel(instanceId: $instanceId)
  }
`;
export const carsOnline = /* GraphQL */ `
  query CarsOnline($online: Boolean!) {
    carsOnline(online: $online) {
      ActivationId
      AgentVersion
      ComputerName
      IamRole
      InstanceId
      IpAddress
      IsLatestVersion
      LastPingDateTime
      Name
      PingStatus
      PlatformName
      PlatformType
      PlatformVersion
      RegistrationDate
      ResourceType
      fleetId
      fleetName
    }
  }
`;
export const getAllFleets = /* GraphQL */ `
  query GetAllFleets {
    getAllFleets {
      carIds
      createdAt
      createdBy
      fleetId
      fleetName
    }
  }
`;
export const getAllModels = /* GraphQL */ `
  query GetAllModels {
    getAllModels {
      md5DateTime
      modelFilename
      modelId
      modelKey
      modelMD5
      modelMetadataMD5
      racerIdentityId
      racerName
      uploadedDateTime
    }
  }
`;
export const getEvents = /* GraphQL */ `
  query GetEvents {
    getEvents {
      countryCode
      createdAt
      createdBy
      eventDate
      eventId
      eventName
      landingPageConfig {
        links {
          linkDescription
          linkHref
          linkName
        }
      }
      raceConfig {
        maxRunsPerRacer
        numberOfResetsPerLap
        raceTimeInMin
        rankingMethod
        trackType
      }
      sponsor
      tracks {
        fleetId
        leaderBoardFooter
        leaderBoardTitle
        trackId
      }
      typeOfEvent
    }
  }
`;
export const getLandingPageConfig = /* GraphQL */ `
  query GetLandingPageConfig($eventId: String!) {
    getLandingPageConfig(eventId: $eventId) {
      links {
        linkDescription
        linkHref
        linkName
      }
    }
  }
`;
export const getLeaderboard = /* GraphQL */ `
  query GetLeaderboard($eventId: ID!, $trackId: ID) {
    getLeaderboard(eventId: $eventId, trackId: $trackId) {
      config {
        leaderBoardFooter
        leaderBoardTitle
        sponsor
      }
      entries {
        avgLapTime
        avgLapsPerAttempt
        countryCode
        eventId
        fastestLapTime
        lapCompletionRatio
        numberOfInvalidLaps
        numberOfValidLaps
        racedByProxy
        trackId
        username
      }
    }
  }
`;
export const getModelsForUser = /* GraphQL */ `
  query GetModelsForUser($racerName: String!) {
    getModelsForUser(racerName: $racerName) {
      md5DateTime
      modelFilename
      modelId
      modelKey
      modelMD5
      modelMetadataMD5
      racerIdentityId
      racerName
      uploadedDateTime
    }
  }
`;
export const getQuarantinedModels = /* GraphQL */ `
  query GetQuarantinedModels {
    getQuarantinedModels {
      md5DateTime
      modelFilename
      modelId
      modelKey
      modelMD5
      modelMetadataMD5
      racerIdentityId
      racerName
      uploadedDateTime
    }
  }
`;
export const getRaces = /* GraphQL */ `
  query GetRaces($eventId: String!) {
    getRaces(eventId: $eventId) {
      createdAt
      eventId
      laps {
        autTimerConnected
        isValid
        lapId
        resets
        time
      }
      raceId
      racedByProxy
      trackId
      userId
    }
  }
`;
export const getUploadModelToCarStatus = /* GraphQL */ `
  query GetUploadModelToCarStatus(
    $carInstanceId: String!
    $ssmCommandId: String!
  ) {
    getUploadModelToCarStatus(
      carInstanceId: $carInstanceId
      ssmCommandId: $ssmCommandId
    ) {
      carInstanceId
      ssmCommandId
      ssmCommandStatus
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers {
    listUsers {
      Attributes {
        Name
        Value
      }
      Enabled
      MFAOptions {
        Name
        Value
      }
      Roles
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      sub
    }
  }
`;
export const updateLeaderboardConfigs = /* GraphQL */ `
  query UpdateLeaderboardConfigs(
    $eventId: String!
    $leaderboardConfigs: [LeaderBoardConfigInputType]!
  ) {
    updateLeaderboardConfigs(
      eventId: $eventId
      leaderboardConfigs: $leaderboardConfigs
    ) {
      leaderBoardFooter
      leaderBoardTitle
      sponsor
    }
  }
`;
